module.exports = __webpack_public_path__ + "img/mu.e90cc7b8.svg";